module.exports = __webpack_public_path__ + "static/media/landbot-logo.8bff0408.png";